import { render, staticRenderFns } from "./OnboardingWizard.vue?vue&type=template&id=074cae70&scoped=true"
import script from "./OnboardingWizard.vue?vue&type=script&lang=js"
export * from "./OnboardingWizard.vue?vue&type=script&lang=js"
import style0 from "./OnboardingWizard.vue?vue&type=style&index=0&id=074cae70&prod&scoped=true&lang=css"
import style1 from "./OnboardingWizard.vue?vue&type=style&index=1&id=074cae70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074cae70",
  null
  
)

export default component.exports